import {defineStore} from 'pinia'
import {inject} from "vue";
import {SmartSearchConfigInterface} from "@/core/types";
import {useUrlStore} from "@/store/SerpPage/UrlStore";

import {SanitizeValue} from "@/core/utils";


export const useSearchQueryStore = defineStore('searchQueryStore', {
  state: () => {
    return {
      initialized: false,
      searchQuery: '',
      isHashBeforeSearchParams: false
    }
  },
  getters: {
    getIsHashBeforeSearchParams(state) {
      return state.isHashBeforeSearchParams
    },
    hasQuery(state) {
      return state.searchQuery !== ''
    },
    
    getSearchQuery(state) {
      if (!state.initialized) {
        useSearchQueryStore().initSearchQuery()
      }
      return SanitizeValue(state.searchQuery)
    },
    getSerpRedirectUrl(): string {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
      
      const executionPath = process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_PUBLIC_PATH
        : ''
      if (this.isHashBeforeSearchParams) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return encodeURI(`${executionPath}${SmartSearchConfig.value.serpRedirectUrl}#?q=${this.getSearchQuery}`)
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return encodeURI(`${executionPath}${SmartSearchConfig.value.serpRedirectUrl}?q=${this.getSearchQuery}`)
    }
  },
  actions: {
    getSearchParams() {
      return useUrlStore().decomposeUrl().searchParams
    },
    updateQuery(newQuery: string) {
      this.searchQuery = SanitizeValue(newQuery)
    },
    clearQuery() {
      this.searchQuery = ''
    },
    initSearchQuery() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.isHashBeforeSearchParams = SmartSearchConfig.value.appConfiguration.useHashBeforeSearchParams ?? false;
      const urlParams = useSearchQueryStore().getSearchParams();
      this.searchQuery = SanitizeValue(urlParams.get('q') ?? '')
      this.initialized = true
    }
  },
})
